export const INSIGHTS_BREADCRUMB = {
  title: "Insights",
  path: () => "/app/dashboards?tab=insights",
};
